import { useContext, useEffect, useState } from 'react';
import {
    getBedrooms
} from '../options';
import { ConfigStateContext } from 'shared-components/Contexts/Configurations/context';
import { useFilters } from 'shared-components/Components/Filters/Filters.hook';
import InputFilterBox from '../InputFilterBox/web';
import { firstLetterToUppercase, getOptionsSelectedText } from 'src/utils/Functions';
import { useSearchResultsFilters } from '../../Filters/SearchResultsFilters.hook';

export const BedroomsFilter = () => {
    const { filters } = useFilters();
    const { country_code, translations } = useContext(ConfigStateContext);
    const { changeFiltersAndUpdateURL: changeFilters } = useSearchResultsFilters();
    const [bedroomsText, setBedroomsText] = useState(firstLetterToUppercase(translations?.habitaciones));

    const bedrooms = getBedrooms(translations)
    const bedroomsByCountry = bedrooms.filter(bedroom => bedroom.countries.includes(country_code ? country_code.toUpperCase() : ""))
    const bedroomsList = bedroomsByCountry.map((bedroom) => ({ text: bedroom.text, value: bedroom.value }))

    useEffect(() => {
        if (filters.bedrooms) {
            const text = getOptionsSelectedText(bedroomsByCountry, filters?.bedrooms)
            setBedroomsText(text)
        } else {
            setBedroomsText(firstLetterToUppercase(translations?.habitaciones))
        }
    }, [filters.bedrooms])

    const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const currentBedroomsFilter = filters.bedrooms ?? []
        const { value, checked } = e?.target
        const parsedValue = Number(value)
        let updatedBedroomsFilter = [];

        if (checked) {
            updatedBedroomsFilter = [...currentBedroomsFilter, parsedValue];
        } else {
            updatedBedroomsFilter = currentBedroomsFilter.filter(b => b !== parsedValue);
        }

        const newBedroomsFilter = bedroomsList.filter(item => updatedBedroomsFilter.includes(item.value));

        changeFilters({ bedrooms: newBedroomsFilter });
    }

    return (
        <InputFilterBox label={bedroomsText}>
            <div className="optionList">
                {bedroomsList?.map((val, i) => {
                    return (
                        <div key={val.text + "-" + i} className="optionList__option">
                            <input
                                type="checkbox"
                                className="checkBoxCustomInput"
                                onChange={handleOnChange}
                                name={"bedroomsList"}
                                id={val.text}
                                value={val.value}
                                checked={
                                    typeof filters?.bedrooms !== "undefined" &&
                                    filters?.bedrooms.includes(val.value)
                                }
                            />
                            <label htmlFor={val.text}>{val.text}</label>
                        </div>
                    );
                })}
            </div>
        </InputFilterBox>
    )
}
